##
#
# Confirm Click - Confirm your action on click
# Ex: <a href="" data-confirm-click="Are you sure" confirmed-click="someAction()" confirmed-click-cancel="cancelAction()">Do some action</a>
#
##
angular
	.module 'App.Directive'
	.directive 'confirmClick', ['$filter', '$uibModal', ($filter, $uibModal) ->
		restrict: 'A'
		link: (scope, elem, attrs) ->
			elem.bind 'click', ->
				$uibModal
					.open
						templateUrl: '@directive/confirmed-click/confirmed-click.view.html'
						scope: scope
						size: 'sm'
						controller: ($scope) ->
							$scope.message = attrs.confirmClick || $filter('translate')('wbo.directive.confirm')
					.result
					.then(
						->
							scope.$eval(attrs.confirmedClick) if attrs.confirmedClick
						->
							scope.$eval(attrs.confirmedClickCancel) if attrs.confirmedClickCancel
					)

				return false
	]
